import React from 'react';
import ActionButton from '../../../Components/Common/ActionButton';

const DocumentRow = ({ doc, badgeLabel, badgeClass, onView }) => (
  <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3'>
    <div className='d-flex align-items-center gap-3 min-width-0'>
      <div
        className='bg-light rounded d-flex align-items-center justify-content-center'
        style={{ width: '48px', height: '48px' }}
      >
        <i
          className={`ri-file-text-line fs-24 ${
            doc.hasCounter
              ? 'text-warning'
              : doc.isMasterDocument
                ? 'text-success'
                : 'text-primary'
          }`}
        />
      </div>
      <div>
        <h6 className='fw-medium text-dark mb-1'>
          {doc.documentName || doc.customFileName || '-'}
        </h6>
        <div className='d-flex align-items-center gap-2 small'>
          <span className={`badge ${badgeClass}`}>{badgeLabel}</span>
          {doc.updated && (
            <span className='text-muted'>Updated: {doc.updated}</span>
          )}
        </div>
      </div>
    </div>
    <div className='d-flex align-items-center flex-wrap gap-2 flex-shrink-0'>
      <ActionButton
        variant='secondary'
        onClick={() => onView(doc.actualUrl)}
        disabled={!doc.actualUrl}
      >
        Download
      </ActionButton>
      <ActionButton
        variant='secondary'
        onClick={() => onView(doc.actualUrl)}
        disabled={!doc.actualUrl}
      >
        View
      </ActionButton>
    </div>
  </div>
);

export default DocumentRow;
